module.exports = __webpack_public_path__ + "media/3-11.60915792.wav";